export default {
    init() {
        /* Script for sequencing the video */
        if ($(".module-parallax-img")[0]) {
            $(".module-parallax-img").each(function() {

                var parallaxImg = $(this);
            });
        }
    }
}